/**
 * @file waitlist.js
 *
 * Waitlist API Service
 *
 * API calls to /api/v1/waitlist.
 * Patient-facing: join, leave, my entries.
 * Professional-facing: toggle, list, count.
 */
import api from "./api";

export const waitlistService = {
  /** Patient joins a professional's waitlist. */
  join: (data) => api.post("/waitlist/join", data),
  /** Patient removes themselves from a waitlist entry. */
  leave: (id) => api.delete(`/waitlist/${id}`),
  /** Get patient's active waitlist entries across all professionals. */
  myEntries: () => api.get("/waitlist/my-entries"),
  /** Get professional's waitlist entries. */
  professionalEntries: () => api.get("/waitlist/professional/me"),
  /** Get active waitlist count for professional (dashboard). */
  professionalCount: () => api.get("/waitlist/professional/me/count"),
};
